import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-instruction-entry-grid',
  templateUrl: './instruction-entry-grid.component.html',
  styleUrls: ['./instruction-entry-grid.component.css']
})
export class InstructionEntryGridComponent implements OnInit {
  title="Instruction Entry List"
  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/accountmaster/instruction-entry-grid/instruction-entry-grid.component.ts